export default __webpack_public_path__ + "static/media/PARQUET.239555fe.jpg";